export enum PolicyImportEvents {
  OnImportFileNameChange = 'onImportFileNameChange',
}

export class OnImportFileNameChange extends CustomEvent<string> {
  constructor(value: string) {
    super(PolicyImportEvents.OnImportFileNameChange, {
      detail: value,
      bubbles: true,
      composed: true,
    });
  }
}
